import { useState, useMemo } from "react";

export default function useTable ({table_headers}) {
    const [headers, setHeaders] = useState(table_headers ?? [])
    const [rawData, setRawData] = useState([]);
    const [sort, setSort] = useState({ column: null, direction: null });

     /**
   * handle sort — only updates the active sort column/direction. The actual
   * ordering is derived from `rawData` + `sort` below, so the sort survives
   * any data refresh (e.g. toggling a rule refetches the list).
   *
   * @param {string} columnName - column name in data
   */
  function handleSortByColumn(columnName) {
    setSort(prevSort =>
      prevSort.column === columnName
        ? { column: columnName, direction: prevSort.direction === "asc" ? "desc" : "asc" }
        : { column: columnName, direction: "asc" }
    );
  }

  // Derive the displayed rows from the raw data and the active sort. Because
  // this recomputes whenever `rawData` changes, the table always shows the
  // sorted order — even after the data is replaced by a background refresh.
  const data = useMemo(() => {
    if (!sort.column || !sort.direction) return rawData;
    const { column, direction } = sort;
    return [...rawData].sort((a, b) => {
      // two adjacent columns
      const columnA = a[column] ?? "";
      const columnB = b[column] ?? "";

      // comparing function between different types of datas
      if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else if (typeof columnA === "boolean" && typeof columnB === "boolean") {
        if (columnA && !columnB) {
          return direction === "asc" ? -1 : 1;
        } else if (!columnA && columnB) {
          return direction === "asc" ? 1 : -1;
        } else {
          return 0;
        }
      } else {
        const columnALower = columnA.toString().toLowerCase();
        const columnBLower = columnB.toString().toLowerCase();
        if (columnALower < columnBLower) {
          return direction === "asc" ? -1 : 1;
        } else if (columnALower > columnBLower) {
          return direction === "asc" ? 1 : -1;
        } else {
          return 0;
        }
      }
    });
  }, [rawData, sort]);

    return {
        headers,
        data,
        sort,
        setHeaders,
        setData: setRawData,
        setSort,
        handleSortByColumn
    }
}
